import { render, staticRenderFns } from "./CompanyImages.vue?vue&type=template&id=252c10f8&"
import script from "./CompanyImages.vue?vue&type=script&lang=js&"
export * from "./CompanyImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports